/* eslint-disable default-case */
import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import Address from "~/common/components/Address";
import DatePicker from "~/common/components/DatePicker";
import FileUploader from "~/common/components/FileUploader";
import Form, { Group } from "~/common/components/Form";
import Input from "~/common/components/Input";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import Radio from "~/common/components/Radio";
import Tag from "~/common/components/Tag";
import Textarea from "~/common/components/textarea";
import { AppContext } from "../../RoundRegContext";
import { useTranslation } from "react-i18next";
import translation from "~/i18n";
import Select from "~/common/components/Select";
import MultiCheckboxSelect from "~/common/components/MultiCheckboxSelect";

const PreviewInquiryModal = ({ inquiryPreModal, setInquiryPreModal }) => {
	const { t } = useTranslation();
	const { list } = useContext(AppContext);
	const inquiryOutputForm = useForm();

	return (
		<ModalTemplate
			modalState={inquiryPreModal}
			setModalToggle={setInquiryPreModal}
			title={t("pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.title")}
			width={1100}
			className="inquiry-preview-modal"
		>
			<div className="modal-content">
				<div className="round-form-head">
					<b>{t("pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.form")}</b>
					<div className="round-title">
						<h3>{list[0].title}</h3>
						<p>{list[0].content}</p>
					</div>
				</div>
				<Form useForm={inquiryOutputForm}>
					{list.map((d, idx) => {
						switch (d.type) {
							case "SHORT":
								return (
									<Input
										required={d.required}
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.short"
											)
										}
										name="short"
										key={idx}
									/>
								);
							case "LONG":
								return (
									<Textarea
										required={d.required}
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.long"
											)
										}
										name={`long.${idx}`}
										showCount={false}
										key={idx}
									/>
								);
							case "CHOICE":
								const optionsData = d.selectOption?.map((dt) => {
									return { label: dt.title, value: dt.title };
								});

								return (
									<Radio
										required={d.required}
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.choice"
											)
										}
										name="choice"
										key={idx}
										options={optionsData}
										className="radio-form-wrap"
									/>
								);
							case "ALTERNATIVE":
								const optionsDataAlter = d.selectOption?.map((dt) => {
									return { label: dt?.title, value: dt?.title };
								});
								return (
									<Radio
										required={d.required}
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.alternative"
											)
										}
										name="alternative"
										key={idx}
										options={optionsDataAlter}
										className="radio-form-wrap"
									/>
								);
							case "AGREE":
								return (
									<Group
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.agree"
											)
										}
										key={idx}
										required={d.required}
									>
										<Textarea
											name="agree"
											placeholder={d.content}
											readonly={true}
										/>
										<label className={`checkbox-custom`}>
											<input type="checkbox" />
											<span className="checkmark" />
											<span className="checkbox-label">
												{d.agreeDescription
													? d.agreeDescription
													: t(
															"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.agree-label"
													  )}
											</span>
										</label>
									</Group>
								);
							case "TEXT":
								const color =
									d.color === "red"
										? "#ff3c00"
										: d.color === "blue"
										? "#00a4ff"
										: d.color === "green"
										? "#71bb30"
										: d.color === "yellow"
										? "#ffd800"
										: "#ff3c00";
								return (
									<p className="certified-phrase" style={{ color: color }}>
										{d.title}
									</p>
								);
							case "FILE":
								return (
									<Group
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.file"
											)
										}
										key={idx}
										required={d.required}
									>
										<FileUploader name="file" />
										<ul className="note-list">
											{d.content &&
												d.content.split("\n").map((text) => {
													return (
														<li>
															<span>
																{text}
																<br />
															</span>
														</li>
													);
												})}
											<li className="default-note">
												{t(
													"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.maxSize"
												)}
											</li>
										</ul>
									</Group>
								);
							case "LINK":
								return (
									<Group
										label={d.title || "링크추가"}
										required={d.required}
										key={idx}
									>
										<Input name="link" />
										<ul className="note-list">
											<li>
												{t(
													"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.link-note"
												)}
											</li>
										</ul>
									</Group>
								);
							case "ADDRESS":
								return (
									<Address
										required={d.required}
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.address"
											)
										}
										key={idx}
										name={{
											postCode: "zipCode",
											address1: "address",
											address2: "addressDetail",
										}}
									/>
								);
							case "TAG":
								return (
									<Tag
										required={d.required}
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.tag"
											)
										}
										name="tag"
										key={idx}
										className="c__tag-wrap"
									/>
								);
							case "DATE":
								return (
									<DatePicker
										required={d.required}
										label={
											d.title ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.date"
											)
										}
										name="date"
										key={idx}
									/>
								);
							case "CATEGORY":
								return (
									<h4 className="category-title" key={idx}>
										{d.title}
									</h4>
								);
							case "SELECT":
								return (
									<Select
										label={
											`${d.title}` ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.select"
											)
										}
										name={`select${d.title}${idx}`}
										options={d?.selectOption.map((q) => {
											return { label: q, value: q };
										})}
										required={d.required}
										className="c__tag-wrap f__column"
										card={d}
										key={idx}
									/>
								);
							case "MULTISELECT":
								return (
									<MultiCheckboxSelect
										label={
											`${d.title}` ||
											translation.t(
												"pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.multiselect"
											)
										}
										valueKey={"value"}
										name={`multiselect${d.title}${idx}`}
										options={d?.selectOption.map((q) => {
											return { label: q, value: q };
										})}
										placeholder={"선택해주세요."}
										required={d.required}
										selectedValues={[]}
										className="f__column"
										key={idx}
									/>
								);
						}
					})}
				</Form>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => setInquiryPreModal(false)}
				>
					{t("pages.round.RoundReg.Inquiry.modals.PreviewInquiryModal.confirm")}
				</button>
			</div>
		</ModalTemplate>
	);
};

export default React.memo(PreviewInquiryModal);
